import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGUAGES } from '../i18n';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Language selector — persists to localStorage (via i18next) and, when logged in,
// to the user's profile on the backend for cross-device persistence.
const LanguageSwitcher = ({ authed = false }) => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  const change = async (code) => {
    await i18n.changeLanguage(code);
    try {
      const stored = JSON.parse(localStorage.getItem('user') || 'null');
      if (stored) { stored.language = code; localStorage.setItem('user', JSON.stringify(stored)); }
    } catch (e) { /* ignore */ }
    if (authed) {
      axios.put(`${API}/me/language`, { language: code }).catch(() => {});
    }
  };

  return (
    <div className="relative flex items-center" data-testid="language-switcher">
      <Globe className="w-4 h-4 text-slate-400 absolute left-2 pointer-events-none" />
      <select
        value={current}
        onChange={(e) => change(e.target.value)}
        aria-label="Select language"
        className="pl-7 pr-2 py-1.5 text-sm rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer appearance-none"
        data-testid="language-select"
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.native}</option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
